var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.company)?_c('div',[_c('GeneralData',{on:{"input":_vm.formSaved},model:{value:(_vm.company),callback:function ($$v) {_vm.company=$$v},expression:"company"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }